const locale = {
  bestSelling: { mostAccessed: 'Imóveis mais acessados' },
}

export default locale
